import { render, staticRenderFns } from "./GlobalError.vue?vue&type=template&id=17b0d8c5&scoped=true&"
import script from "./GlobalError.vue?vue&type=script&lang=js&"
export * from "./GlobalError.vue?vue&type=script&lang=js&"
import style0 from "./GlobalError.css?vue&type=style&index=0&id=17b0d8c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b0d8c5",
  null
  
)

export default component.exports